module.exports = __webpack_public_path__ + "img/lab-aplicaciones.0fd2f820.png";